import { render, staticRenderFns } from "./Multicolli.vue?vue&type=template&id=eddd2eee&scoped=true&"
import script from "./Multicolli.vue?vue&type=script&lang=js&"
export * from "./Multicolli.vue?vue&type=script&lang=js&"
import style0 from "./Multicolli.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Multicolli.vue?vue&type=style&index=1&id=eddd2eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddd2eee",
  null
  
)

export default component.exports